import { useEffect, useState } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom'
import { adminGetUserNameApi } from '../../../api/admin/user'
import { swalErrorAlert } from '../../../utils/swal/swal'
import { useAdminStore } from '../../../store/userStore'
import { SearchForm } from '../common/SearchForm'

/* Components */
import SchoolRecordVer1List from '../../../components/admin/schoolRecord/SchoolRecordVer1List'
import SchoolRecordVer2List from '../../../components/admin/schoolRecord/SchoolRecordVer2List'
import AdminFileManage from '../../../components/admin/schoolRecord/AdminFileManage'


const AdminSchoolRecordListPage = () => {
    const { adminInfo } = useAdminStore(state => state)
    const adminType = adminInfo?.type ? adminInfo?.type : ''

    const location = useLocation();
    const pathname = location.pathname
    const params = new URLSearchParams(location.search);
    const searchTerm = params.get('search') ? params.get('search').toString() : ''

    const { userId } = useParams()

    const [userName, setUserName] = useState('')

    const [tab, setTab] = useState('ver2')

    useEffect(() => {
        const getUserName = async (userId) => {
            if (!userId) {
                setUserName('')
                return
            }

            try {
                const response = await adminGetUserNameApi(userId)

                if (response.data?.code === 200) {
                    const userName = response.data?.resData?.user_name
                    setUserName(userName)
                } else {
                    setUserName('')
                }
                return

            } catch (error) {
                console.log(error);

                setUserName('')
                swalErrorAlert()
                return
            }
        }

        getUserName(userId)
    }, [])


    return (
        <div className="container-fluid">
            {/* Page Heading */}
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 className="h3 mb-0">생활기록부 관리</h1>
            </div>

            {/* Page Tab */}
            <div className='mb-5'>
                <ul className="nav nav-pills">
                    <li className="nav-item">
                        <button type='button' className={tab === 'ver2' ? 'nav-link active' : 'nav-link'} onClick={() => { setTab('ver2') }}>생활기록부 리스트</button>
                    </li>
                    <li className="nav-item">
                        <button type='button' className={tab === 'file' ? 'nav-link active' : 'nav-link'} onClick={() => { setTab('file') }}>생활기록부 관련 파일 관리(학생업로드)</button>
                    </li>
                    <li className="nav-item">
                        <button type='button' className={tab === 'ver1' ? 'nav-link active' : 'nav-link'} onClick={() => { setTab('ver1') }}>생활기록부 이전 버전</button>
                    </li>
                </ul>
            </div>

            {/* Page Content */}
            <div className="">
                <div className="card shadow mb-4">
                    <div className="card-header py-3">
                        <div className='d-flex justify-content-between align-items-center'>
                            <h6 className="m-0 font-weight-bold">
                                <b className='me-2'>{userName}</b>
                                학생 생활기록부
                                {tab === 'ver2' && ' 초안'}
                                {/* {tab === 'final' && ' Final'} */}
                                {tab === 'file' && ' 파일 관리'}
                                {tab === 'ver1' && ' 이전버전'}
                            </h6>

                            {tab === 'ver2' &&
                                <SearchForm pathname={pathname} searchTerm={searchTerm} placeHolder={'내용을 검색해 주세요.'} />
                            }
                        </div>
                    </div>

                    <div className="card-body" style={{ height: "calc(100vh - 400px)", overflowX: "auto" }}>
                        {tab === 'ver2' && <SchoolRecordVer2List userId={userId} searchTerm={searchTerm} adminType={adminType} />}
                        {tab === 'file' && <AdminFileManage userId={userId} fileType={'schoolRecord'} />}
                        {tab === 'ver1' && <SchoolRecordVer1List userId={userId} searchTerm={searchTerm} />}
                    </div>

                    <div className='card-footer'>
                        <div className='text-end'>
                            <Link to={`/hy-admin/school-record`} className='btn btn-secondary'>학생 리스트로 이동</Link>
                            {adminType === 'admin' &&
                                <Link to={`/hy-admin/school-record/write/${userId}`} className='btn btn-primary ms-2'>생활기록부 작성</Link>}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default AdminSchoolRecordListPage